<template>
  <div class="ba-ranking" v-if="journeyOptions" :class="domain.shared">
    <dimmed v-if="isHeatmapRegistration">
      <heatmap-registration class="insert-page-wrap"
        v-if="isHeatmapRegistration"
        :timezone="domain.timezone"
        :timezoneName="domain.timezoneName"
        :pageData="nodeDataForHeatmap"
        :isEditMode="isHeatmapEditMode"
        @onCloseLayer="onCloseHeatmapRegistration"
        @isShiftJam="isShiftJamEmit"/>
    </dimmed>
    <dimmed v-if="isShiftJam" :style="{'border-radius': '14px'}">
      <shift-jam
        @isShiftJam="isShiftJam = $event"
        @moveJam="moveJam"
        @isChargingJam="isChargingJamCheck"
        :heatmapJam="baApplyBasketCount"
        :remainJam="totalRemainJam">
      </shift-jam>
    </dimmed>
    <dimmed v-if="isChargingJam">
      <charge-pv
          :topUpJam="true"
          :remainJam="remainJam"
          @remainJamChange="setRemainJam"
          @showTopUpAlert="showTopUpAlert = $event"
          @result="TopUpResult = $event"
          @closeLayer="isChargingJam = false"/>
    </dimmed>
    <dimmed v-if="showTopUpAlert">
      <alert :icon="TopUpResult ? 'icon--validation-pass' : 'icon--alert'"
      :title="TopUpResult ? $t('plan.alert[0].title') : $t('plan.alert[1].title')"
      :description="TopUpResult ? $t('plan.alert[0].description') : $t('plan.alert[1].description')"
      :submit="$t('common.confirm')"
      @onSubmit="closeTopUpAlert" />
    </dimmed>
    <div class="pane-wrap"
        :class="{
          disabled: reportShowing,
          scrolled: searchLoading || searched || scrollTop > 0,
          scrolledMore: searched ||scrollTop >= 510 }"
        ref="paneWrap">
      <div class="info-wrap"
          :class="{ searched: !searchLoading && searched }">
        <div v-if="infoData"
            class="info">
          <div class="custom" v-if="isCustomNodeAvailable">
            <span class="label">
              {{ $t('customTag.label') }}
            </span>
            <ba-switch :value="isCustomNode"
                       :default="isCustomNode"
                       :width="44"
                       :size="'small'"
                       :theme="searchLoading || searched || scrollTop > 0 ? 'dark' : 'light'"
                       :disabled="isCustomDisabled"
                       v-btf-tooltip:top.start="{contents: isCustomDisabled ? $t('customTag.disabled', { date: customRegDate }) : ''}"
                       @change="onCustomTag" />
          </div>
          <div class="domain">
            <button :class="{ active: searchFavorite }"
                    :disabled="(!searchFavorite && numBookmarks < 1) || !canBookmarkSearch || isCustomNode"
                    @click="onSearchFavoriteChange">
              <i class="icon icon--favorite"></i>
              <i class="icon icon--favorite off"></i>
              <span class="bookmark-text" v-html="$t('bookmark.bookmarkButtonText')"></span>
            </button>
          </div>
          <div class="search"
              id="rankingSearch"
              :class="{ searching: searchTyping }">
            <div class="search-option" :class="{custom: isCustomNode}" v-if="!isExactMatchType">
              <ba-dropdown v-if="!isCustomNode" :value="searchOption"
                          :items="searchOptionItems"
                          :disabled="noData"
                          :width="'100%'"
                          :color="searchLoading || searched || scrollTop > 0 ? 'dark' : 'light'"
                          @input="onSearchOptionChange" />
              <span v-else>{{ $t('registration.detailTarget.tagName') }}</span>
            </div>

            <div class="search-input">
              <input type="text"
                    ref="keyword"
                    :disabled="noData"
                    v-model="keyword"
                     :placeholder="isExactMatchType ? $t('ranking.urlSearchPlaceHolder'): ''"
                    @focus="onStartSearching"
                    @keyup.enter="onSearch" />
            </div>

            <button class="search-button"
                    :disabled="noData"
                    @click="onSearch">
              <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g fill="none" fill-rule="evenodd" transform="translate(2.5 2.5)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                  <circle cx="4.5" cy="4.5" r="4.5"/>
                  <path d="M10.887 10.887 8 8"/>
                </g>
              </svg>
            </button>
          </div>
          <template v-if="infoData">
            <div class="info-data"
                :class="{ searching: searchTyping }">
              <div class="url">
                <em>{{ isCustomNode ? $t('common.unit.tag') : $t('common.unit.page') }}</em>
                : {{ infoData.count | thousand }}
              </div>
              <!--              <div v-if="infoData.session"-->
              <!--                   class="session">-->
              <!--                <em>{{ $t('common.session') }}</em>-->
              <!--                : {{ infoData.session | thousand }}-->
              <!--              </div>-->
              <div class="pv">
                <em>{{ $t('common.pv') }}</em>
                : {{ (originRankingData && originRankingData.pv) || infoData.pv | thousand }}
              </div>
              <div v-if="samplingReliabilityText" class="sampling-reliability">
                <div class="icon-wrap">
                  <i class="icon icon--bell-white size-20"></i>
                </div>
                <div class="message">{{ samplingReliabilityText }}</div>
              </div>
<!--              <div class="alarm" v-if="isSampling">-->
<!--                <i class="icon icon&#45;&#45;notification-alarm"></i>-->
<!--                <span>{{$t('resample.info', {percent: originRankingData.reliability})}}</span>-->
<!--              </div>-->
            </div>
            <div class="buttons">
              <div class="group" :class="{disabled: isCustomNode}" v-if="!isExactMatchType">
                <span class="label">
                  <i class="icon icon--group"></i>
                  {{ $t('group.label') }}
                </span>

                <ba-switch :value="grouping"
                           :default="grouping"
                           :width="44"
                           :size="'small'"
                           :theme="searchLoading || searched || scrollTop > 0 ? 'dark' : 'light'"
                           :disabled="isCustomNode"
                           @change="onGroupingChange" />

                <div class="group-setting"
                     :class="{ active: grouping, moving: groupOning }">
                  <ba-dropdown class="group-options"
                               :value="group"
                               :items="groupItems"
                               :width="'196px'"
                               :disabled="noData || groupItems.length < 2"
                               :color="searchLoading || searched || scrollTop > 0 ? 'dark' : 'light'"
                               @input="onGroupChange" />
                </div>
              </div>
              <div class="setting__wrap">
                <button class="setting" :class="{ theme: searchLoading || searched || scrollTop > 0 ? true : false, disabled: isCustomNode}" @click="movingGroup = true">
                  <i class="icon icon--setting-size16" :class="{ disabled: noData || isCustomNode, light: searchLoading || searched || scrollTop > 0 ? true : false }"></i>
                  {{ $t('group.pageEdit') }}</button>
              </div>
              <div class="excel">
                <button :title="$t('journey.excel.title')"
                        @click="onDownloadExcel">
                  <i class="icon icon--excel"></i>
                </button>
              </div>
              <button class="ai-report-button" :disabled="!ableToShowAiReport" @click="onClickAiReport">
                <i class="icon icon--ai-blue" />
                <span class="text-contents">Report</span>
              </button>
            </div>
          </template>
        </div>
        <div v-if="infoData"
             class="searching-keyword">
          <div class="searching-wrap">
            <button class="reset"
                    @click="resetSearch">
              <i class="icon icon--arrow-left-white"></i>
            </button>
            <template v-if="infoData.count">
              <p class="search-keyword"
                 v-html="$t('ranking.searchBy', { keyword: this.listOption.keyword })"></p>
              <p class="search-result">
                <em>{{ infoData.count | thousand }}</em>{{ $t('common.searchResult') }}
              </p>
            </template>
            <template v-else>
              <p class="search-keyword"
                 v-html="$t('common.noResult')"></p>
            </template>
          </div>
        </div>
      </div>
      <template v-if="infoData && cardData && rankingData">
        <div v-if="infoData.pv > 0" v-show="!searched && !searchLoading" class="benchmark-wrap">
          <div :class="['match-type', domain.matchType]"
            v-btf-tooltip:top.start="{contents: isExactMatchType ? $t('common.matchType.exactGuide') : $t('common.matchType.simpleGuide'), size: 220}">
            {{ domain.matchType }}
          </div>
          <div class="category-header">
            <template v-if="domainCategory && domainSubCategory && !isCustomNode">
              <div class="category-icon large">
                <i :class="['icon', DOMAIN_CATEGORY_ICON[domainCategory.key], 'size-24']"></i>
              </div>
              <div class="dropdown">
                <div class="selected" @click="isCategorySelectorOpened = true">
                  <span class="label">{{ domainCategory.subcategories[domainSubCategory].title[$i18n.locale] }}</span>
                  <i class="icon icon--arrow-updown"></i>
                </div>
              </div>
            </template>
            <span v-if="isExactMatchType">{{ $t( `benchmark.exactTitle`) }}</span>
            <span v-else-if="isCustomNode">{{ $t( `benchmark.customTagTitle`) }}</span>
            <span v-else-if="domainCategory && domainSubCategory && benchmarkData && benchmarkData.pvPerSession">{{ $t( `benchmark.categoryTitle`) }}</span>
            <span v-else-if="domainCategory && domainSubCategory">{{ $t( `benchmark.noDataTitle`) }}</span>
            <span v-else>{{ $t( `benchmark.defaultTitle`) }}</span>
            <span class="ai-robot-burrow"></span>
            <span v-if="showSegmentNotice" class="segment-notice">{{ $t('benchmark.segmentNotice') }}</span>
          </div>
        </div>
        <transition name="fade">
          <div class="card-wrap"
               v-if="cardData.pv && cardData.pv.data && Object.keys(cardData.pv.data).length > 0"
               v-show="!searched && !searchLoading"
               :class="{ 'no-data': infoData.pv < 1, 'no-transform': heightGap < 250 }">
            <transition name="fade">
              <ranking-card :panelData="cardData"
                            :infoData="infoData"
                            :noData="infoData.pv < 1"
                            :highlight="highlightedType"
                            :benchmark="benchmarkData"
                            :domainCategory="domainCategory"
                            :domainSubCategory="domainSubCategory"
                            @highlight="onTypeHighlighted" />
            </transition>
          </div>
        </transition>
        <transition name="fade">
          <div class="list-wrap"
               :class="{ 'no-data': infoData.count < 1 }"
               v-show="!searchLoading">
            <ranking-list :totalCount="infoData.count"
                          :listData.sync="rankingData"
                          :noData="infoData.count < 1"
                          :sort="listOption.sort"
                          :highlight="highlightedType"
                          :activePage="openNodeReport ? reportShowing : null"
                          :dataTimeString="dataTimeString"
                          :term="listOption.searchOption"
                          :keyword="listOption.keyword"
                          :grouping="grouping"
                          :group="group"
                          @changeSort="changeSort"
                          @makeFavorite="makeFavorite"
                          @showDetail="showReport"
                          @changeState="changeState"
                          @onHeatmapRegistration="onHeatmapRegistration"/>

            <transition name="fade">
              <div class="loading"
                   v-show="listLoading">
                <span class="loading-circle">
                  <svg x="0px" y="0px" viewBox="0 0 150 150">
                    <circle class="loading-inner" cx="75" cy="75" r="60"/>
                  </svg>
                </span>
              </div>
            </transition>

            <back-to-top :refName="'paneWrap'" />
          </div>
        </transition>
      </template>
    </div>

    <transition name="node-report">
      <div class="node-report"
           v-if="reportShowing && reportShowingData && openNodeReport">
        <div class="back-dim"
             @click="hideReport"></div>
        <page-report :pageData="reportShowing"
                     :detailData="reportShowingData"
                     :defaultThumbnail="defaultThumbnail"
                     :captureProcessing="captureProcessing"
                     :group="grouping ? group : false"
                     :timezoneName="domain.timezoneName"
                     :isCustomNode="isCustomNode"
                     @makeFavorite="makeFavorite"
                     @onCapture="onCapture" />
        <button class="close-report"
                @click="hideReport">
          <i class="icon icon--close-arrow-right"></i>
        </button>
      </div>
    </transition>
    <transition name="fade">
      <div class="pane-no-data"
           v-if="noData">
        <i class="icon icon--alert"></i><br>
        <h3 v-html="$t('ranking.noData.title')"></h3>
        <p v-html="$t('ranking.noData.description')"></p>
      </div>
    </transition>

    <transition name="fade">
      <ba-loading class="search-loading"
                  v-if="searchLoading || apiLoading"
                  :applyBackground="true"
                  :showLoadingText="true" />
    </transition>

    <dimmed v-if="isCategorySelectorOpened">
      <category-selector :matched="domain.AICategory2" :selected="domainSubCategory" :category-list="categoryList" @close="isCategorySelectorOpened = false" @select="changeCategory"/>
    </dimmed>
    <dimmed v-if="capturingPage && capturingDevice">
      <ba-capture :pageData="capturingPage"
                  :capturingDevice="capturingDevice"
                  :wholeCaptureProcessing="wholeCaptureProcessing"
                  @onWholeCaptureProcessingChange="wholeCaptureProcessing = $event"
                  @onCaptureProcessing="onCaptureProcessing($event)"
                  @onCloseLayer="capturingPage = null" />
    </dimmed>

    <dimmed v-if="excelAlerting">
      <div class="alert-container alert-excel">
        <alert :title="$t('ranking.excel.limitAlert.title')"
               :description="$t('ranking.excel.limitAlert.description')"
               :cancel="$t('common.confirm')"
               @onCancel="onExcelAlerting(false)" />
      </div>
    </dimmed>

    <dimmed v-if="dateLimitAlerting">
      <div class="alert-container alert-date">
        <alert :title="$t('ranking.dateLimitAlert.title')"
               :description="$t('ranking.dateLimitAlert.description')"
               :cancel="$t('common.confirm')"
               @onCancel="onDateAlerting(false)" />
      </div>
    </dimmed>

    <dimmed v-if="movingGroup">
      <alert :title="$t('group.alert.enter.title')"
             :description="$t('group.alert.enter.description')"
             :cancel="$t('common.cancel')"
             :submit="$t('common.confirm')"
             @onSubmit="onSettingGroup"
             @onCancel="movingGroup = false" />
    </dimmed>

    <dimmed v-if="isHeatmapRegistrationClose">
      <alert
          :icon="'icon--check-green-size50'"
          :title="isHeatmapEditMode ? $t('heatmap.registration.result.modify.title') : $t('heatmap.registration.result.new.title')"
          :description="isHeatmapEditMode ? $t('heatmap.registration.result.modify.description'): $t('heatmap.registration.result.new.description')"
          :submit="$t('common.confirm')"
          @onSubmit="registerDone" />
    </dimmed>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { format } from 'date-fns'

import Excel from '@/libs/excel-export'
import { getRankBenchmark, getAiCategoryList } from '@/api/ai'
import { getReliabilityData } from '@/api/journey'
import { getCardPvData, getCardSessionData, getListData, getDetail, makeFavorite } from '@/api/ranking'
import { getRemainJam } from '@/api/jam'
import { getGroupList } from '@/api/group'
import { checkCaptureExist } from '@/api/capture'
import { calculateLogDateTime, getS3CaptureDatetime, simpleUrl, linkSet } from '@/libs/utils'
import { EventBus } from '@/libs/event-bus'
import { DOMAIN_CATEGORY_ICON } from '@/libs/constants'
import ChargePv from '@/components/user-info/manage-plan/ChargePv'
import ShiftJam from '@/components/user-info/manage-plan/ShiftJam'

import Alert from '@/components/ui/Alert'
import Dimmed from '@/components/ui/Dimmed'
import BaLoading from '@/components/ui/ba/Loading'
import BaDropdown from '@/components/ui/ba/Dropdown'
import BaSwitch from '@/components/ui/ba/Switch'
import BackToTop from '@/components/ui/ba/BackToTop'

import RankingCard from '@/components/ranking/Card'
import RankingList from '@/components/ranking/List'
import PageReport from '@/components/ranking/PageReport'
import BaCapture from '@/components/journey/Capture'
import HeatmapRegistration from '@/components/heatmap/HeatmapRegistration.vue'
import CategorySelector from '@/components/trend/CategorySelector'
import { normalizeHeatmapListData } from '@/libs/heatmap-data-normalizer'
import store from '@/store'

export default {
  name: 'BaRanking',
  components: {
    Alert,
    Dimmed,
    BaLoading,
    BaDropdown,
    BaSwitch,
    BackToTop,
    RankingCard,
    RankingList,
    PageReport,
    BaCapture,
    ChargePv,
    ShiftJam,
    HeatmapRegistration,
    CategorySelector
  },
  computed: {
    ...mapState([
      'planData',
      'userData',
      'journeyPeriod',
      'journeyOptions',
      'numBookmarks',
      'numMaxBookmarks',
      'domain',
      'originRankingData',
      'baApplyBasketCount',
      'totalRemainJam'
    ]),
    isExactMatchType () {
      return this.domain.matchType === 'exact' || this.journeyOptions.matchType === 'exact'
    },
    isCustomNode () {
      return this.journeyOptions.isCustomNode
    },
    isCustomNodeAvailable () {
      if (!this.customRegDate || this.isExactMatchType) {
        return false
      }
      return !(this.customRegDate > this.journeyPeriod.start && this.customRegDate > this.journeyPeriod.end)
    },
    isCustomDisabled () {
      if (this.isCustomNodeAvailable) {
        return this.journeyPeriod.start < this.customRegDate && this.customRegDate <= this.journeyPeriod.end
      } else {
        return true
      }
    },
    customRegDate () {
      const beuCustomRegDateStr = this.domain.beuCustomRegDate ? format(this.domain.beuCustomRegDate, 'YYYY-MM-DD') : null
      return beuCustomRegDateStr
    },
    domainCategory () {
      if (!this.domainSubCategory || !this.categoryList) return null
      const category = Object.entries(this.categoryList).find(([, category]) => category.subcategories && this.domainSubCategory in category.subcategories)
      return category ? { key: category[0], ...category[1] } : null
    },
    searchOptionItems () {
      return [
        {
          text: this.$t('ranking.searchOption.pageTitle'),
          value: 'pageTitle'
        },
        {
          text: this.$t('ranking.searchOption.url'),
          value: 'url'
        }
      ]
    },
    sid () {
      return this.$route.query.sid
    },
    cacheKey () {
      return `${this.dataOption.device}_${this.dataOption.start}_${this.dataOption.end}_${this.dataOption.sid}_
      ${this.dataOption.matchType}_${this.dataOption.exist}_${this.dataOption.refer}_${this.dataOption.limit}_
      ${JSON.stringify(this.dataOption.utm)}_${JSON.stringify(this.dataOption.survey)}_
      ${JSON.stringify(this.dataOption.aiRefererIds)}_
      ${this.dataOption.treeId}_${this.dataOption.groupId}`
    },
    dataTimeString () {
      if (this.cardData) {
        const loadedAt = this.cardData.logDateAt
        const formatText = this.$t('ranking.basedOnFormat')
        return format(loadedAt, formatText)
      } else {
        return ''
      }
    },
    dataOption () {
      return {
        start: this.journeyPeriod.start,
        end: this.journeyPeriod.end,
        sid: this.journeyOptions.sid,
        subSid: this.journeyOptions.subSid,
        matchType: this.journeyOptions.matchType,
        device: this.journeyOptions.device,
        refer: this.journeyOptions.refer,
        aiRefererIds: this.journeyOptions.aiRefererIds,
        exist: this.journeyOptions.exist,
        utm: this.journeyOptions.utm,
        survey: this.journeyOptions.survey,
        bookmark: this.searchFavorite || null,
        firstPath: this.journeyOptions.firstPath === '' ? '' : (this.journeyOptions.firstPath || null),
        isCustomNode: this.journeyOptions.isCustomNode
      }
    },
    ableToShowAiReport () {
      return (!this.domain.shared || this.domain.shared === 'share') && !this.journeyOptions.isCustomNode
    },
    showSegmentNotice () {
      return !this.isExactMatchType && this.journeyPeriod && this.journeyPeriod.start < '2026-02-12'
    }
  },
  created () {
    this.loaded = false

    // if (this.isSampling) {
    //   this.listOption.sort = '-resampleCount'
    // }

    // this.storeBookmarkCount()

    if (this.isExactMatchType) {
      this.searchOption = 'url'
    }
  },
  mounted () {
    this.loadGroupList().then(() => {
      this.onGroupChange(this.groupItems[0].value)
    })

    getAiCategoryList()
      .then(res => {
        this.categoryList = res
      })
      .catch(e => console.log(e))

    EventBus.$onSticky('loadPaneData', async (init) => {
      if (this.isCustomNode) {
        this.searchOption = 'customValue'
      }
      if (this.journeyPeriod.start < '2021-07-01') {
        this.onDateAlerting(true)
      }
      if (!this.journeyOptions.isCustomNode && this.journeyOptions.matchType !== 'exact') {
        const aiCategory2List = this.domain.AICategory2
        if (aiCategory2List && aiCategory2List.length > 0) {
          this.domainSubCategory = aiCategory2List[0]
        }
        await this.getBenchmarkData()
      }
      this.loadData(init)
      this.getReliability()
      EventBus.$clearSticky('loadPaneData')
    })

    EventBus.$onSticky('loadPaneNoData', (value) => {
      this.hideReport()
      if (this.journeyPeriod.start < '2021-07-01') {
        this.onDateAlerting(true)
      }
      EventBus.$emit('onLoading', false)
      this.infoData = null
      this.cardData = null
      this.rankingData = null
      this.noData = value
      this.setGlobalNoData(this.noData)
      EventBus.$clearSticky('loadPaneNoData')
    })

    EventBus.$on('updateBookmark', (updatedKey, value) => {
      for (let i = 0, numRankingData = this.rankingData.length; i < numRankingData; i++) {
        if (this.journeyOptions.matchType === 'exact') {
          if (this.rankingData[i].url === updatedKey) {
            this.$set(this.rankingData[i], 'bookmark', value)
            break
          }
        } else {
          if (this.rankingData[i].gUrlId === updatedKey) {
            this.$set(this.rankingData[i], 'bookmark', value)
            break
          }
        }
      }
    })

    EventBus.$on('updateBaApply', (value) => {
      const gUrlId = value.gUrlId
      for (let i = 0, numRankingData = this.rankingData.length; i < numRankingData; i++) {
        if (this.rankingData[i].gUrlId === gUrlId) {
          this.$set(this.rankingData[i], 'baApply', value)
          break
        }
      }
    })

    this.captureProcessingTimer = setInterval(() => {
      const data = this.captureProcessing
      if (data) {
        checkCaptureExist(data.sid, data.urlId, data.matchType, data.url)
          .then(result => {
            if (Number(this.reportShowing.gUrlId) === Number(data.urlId)) {
              if (result.imagePath && result.imagePath[this.capturingDevice]) {
                const deviceCapture = result.imagePath[this.capturingDevice]
                const newCaptureDate = getS3CaptureDatetime(deviceCapture) || result.captureDate
                if (new Date(this.reportShowingData.realCaptureDate[this.capturingDevice]).toString() !== new Date(newCaptureDate).toString()) {
                  this.captureProcessing = null
                  this.reportShowingData.realCaptureDate[this.capturingDevice] = newCaptureDate
                  this.reportShowingData.imagePath[this.capturingDevice] = result.imagePath[this.capturingDevice]
                  this.reportShowingData.realCaptureUrl[this.capturingDevice] = result.realCaptureUrl[this.capturingDevice]
                  // this.$set(this.captureProcessing, `${data[0]}-${this.capturingDevice}-${data[2]}`, false)
                }
              }
            }
          }).catch(() => {
            this.captureProcessing = null
          })
      }
    }, 5000)

    this.$refs.paneWrap.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  beforeDestroy () {
    clearInterval(this.captureProcessingTimer)
    this.captureProcessingTimer = null
    EventBus.$off('loadPaneData')
    EventBus.$off('loadPaneNoData')

    this.$refs.paneWrap.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapMutations([
      'setBookmarkListLayerOptions',
      'setOriginRankingData',
      'setAIReportData',
      'setGlobalNoData',
      'setJourneyOptions'
    ]),
    ...mapActions([
      'storeBookmarkCount'
    ]),
    async onCustomTag () {
      this.grouping = false
      this.setJourneyOptions({
        ...this.journeyOptions,
        isCustomNode: !this.journeyOptions.isCustomNode
      })

      if (this.journeyOptions.isCustomNode) {
        this.searchOption = 'customValue'
      } else {
        this.searchOption = this.isExactMatchType ? 'url' : 'pageTitle'
      }
      EventBus.$emitSticky('loadPaneData', true)
    },
    resetAIReportData () {
      this.setAIReportData(null)
      if (this.$route.query.aiReportId) {
        const newQuery = { ...this.$route.query }
        delete newQuery.aiReportId
        this.$router.replace({ query: newQuery })
      }
    },
    isChargingJamEmit (data) {
      this.$emit('isChargingJam', data)
    },
    moveJam (baApplyBasketCount, remainJam) {
      store.commit('setBaApplyBasketCount', baApplyBasketCount)
      store.commit('setTotalRemainJam', remainJam)
    },
    isShiftJamEmit (jamCount, totalRemainJam) {
      this.jamCount = jamCount
      this.remainJam = totalRemainJam
      this.isShiftJam = true
    },
    closeTopUpAlert () {
      this.showTopUpAlert = false
    },
    setRemainJam () {
      const payload = {
        user_id: this.userData.userId,
        user_num: this.userData.userNum
      }
      getRemainJam(payload, true).then(res => {
        this.remainJam = res.paidCount + res.freeCount
        store.commit('setTotalRemainJam', res.paidCount + res.freeCount)
      }).catch(err => {
        console.log(err)
      })
    },
    isChargingJamCheck (data) {
      if (data.action) {
        this.remainJam = data.remainJam
        this.isChargingJam = true
      } else {
        this.isChargingJam = false
      }
    },
    loadGroupList () {
      return new Promise(resolve => {
        getGroupList({
          sid: this.dataOption.sid
        }, true).then(result => {
          this.groupItems = []
          for (let group of result) {
            if (group.usableStatus !== 'PENDING') {
              this.groupItems.push({
                text: group.groupName === 'AUTO' ? this.$t('group.automatic') : group.groupName,
                value: group.groupId
              })
            }
          }
          resolve()
        })
      })
    },
    getReliability () {
      if (!(this.domain.preSamplingRate < 100 || this.domain.postSamplingRate < 100)) return

      const requestData = {
        sid: this.journeyOptions.sid,
        matchType: this.journeyOptions.matchType,
        start: this.journeyPeriod.start,
        end: this.journeyPeriod.end
      }

      if (new Date(this.journeyPeriod.start).getTime() >= new Date(this.domain.samplingChangeDate).getTime()) {
        getReliabilityData(requestData).then(res => {
          const result = this.$t('common.samplingReliability.reliabilityRateText', { data: res.reliabilityPercentage.toFixed(1) })
          this.samplingReliabilityText = result
        })
      } else {
        this.samplingReliabilityText = this.$t('common.samplingReliability.reliabilityRateException')
      }
    },
    getBenchmarkData () {
      return new Promise(resolve => {
        const requestData = {
          parentSid: this.domain.parentSid,
          matchType: this.domain.matchType,
          startDate: this.journeyPeriod.start,
          endDate: this.journeyPeriod.end,
          device: this.dataOption.device,
          exist: this.dataOption.exist,
          AICategory2: this.domainSubCategory
        }
        getRankBenchmark(requestData, true).then(res => {
          if (res.pv_per_sess) {
            this.benchmarkData = {}
            this.benchmarkData.pvPerSession = res.pv_per_sess
            this.benchmarkData.intvlPerSession = res.interval_per_sess
            this.benchmarkData.avgInterval = res.interval_per_pv
            this.benchmarkData.top20Rate = {
              pv: res.top20_pv_rate,
              stayInCount: res.top20_conversion_rate,
              dropOff: res.top20_drop_off_rate,
              rollback: res.top20_rollback_rate,
              reload: res.top20_reload_rate,
              interval: res.top20_interval_rate
            }
          } else {
            this.benchmarkData = null
          }
          resolve()
        })
      })
    },
    loadData (init = true) {
      if (init) {
        EventBus.$emit('onLoading', true)
      } else {
        this.searchLoading = true
      }

      if (init) {
        this.infoData = null
      }
      this.cardData = null
      this.rankingData = null

      this.promiseCardData().then(result => {
        if (!result.pv.basicInfo || result.pv.basicInfo.totalUrlCount < 1 || result.pv.basicInfo.totalPV < 1) {
          return EventBus.$emitSticky('loadPaneNoData', true)
        } else {
          EventBus.$emitSticky('loadPaneNoData', false)
        }
        this.noData = false

        this.infoData = {
          count: result.pv.basicInfo.totalUrlCount,
          session: result.pv.basicInfo.totalSessCount || 0,
          pv: result.pv.basicInfo.totalPV,
          bookmarkCount: result.pv.basicInfo.bookmarkCount
        }
        this.cardData = {
          pv: result.pv.cardData,
          session: result.session
        }
        // state.isSampling no use
        // if (this.isSampling) {
        //   // resampling
        //   const originSamplingRate = this.domain.samplingRate || 1
        //   const sample = result.pv.basicInfo.totalSessCount
        //   const origin = result.pv.resampleData.totalSessCount

        //   const pvSamplingRate = sample / origin
        //   const resample = sample / (originSamplingRate / 100)

        //   // console.log(`origin: ${origin}, sample: ${sample}, resample: ${resample}, rate : ${pvSamplingRate}`)

        //   const reliability = getResampleReliability(origin, resample)

        //   const resampleData = {
        //     pv: result.pv.resampleData.totalPV,
        //     pvSamplingRate: pvSamplingRate
        //   }

        //   resampleData.reliability = init ? reliability : this.originRankingData.reliability

        //   this.setOriginRankingData(resampleData)
        // }

        // reliability: reliability
        this.cardData.loadedAt = new Date()
        this.cardData.logDateAt = calculateLogDateTime(this.domain)

        if (!this.dataOption.subSid) {
          this.subDomainItems = [
            {
              text: null,
              value: null
            }
          ]

          const domainList = []
          for (const domainObj of result.pv.basicInfo.subDomains) {
            for (const [sid, domain] of Object.entries(domainObj)) {
              domainList.push({
                text: domain.domain,
                value: sid
              })
            }
          }
          domainList.sort((a, b) => {
            if (a.text.split('.').length < 3) {
              return -1
            } else if (b.text.split('.').length < 3) {
              return 1
            }
            return a.text.localeCompare(b.text)
          })
          for (const domain of domainList) {
            this.subDomainItems.push(domain)
          }
        }

        this.loadNewList().then(async listResult => {
          // this.$set(this.rankingData, normalizeHeatmapListData(listResult), true)
          this.rankingData = normalizeHeatmapListData(listResult)
          this.loaded = true
          if (init) {
            EventBus.$emit('onLoading', false)
          } else {
            this.searchLoading = false
          }
          if (this.$refs.paneWrap.clientHeight > 2400) {
            setTimeout(() => {
              this.onScroll()
            }, 5000)
          }
        }).catch(() => {
          if (init) {
            EventBus.$emit('onLoading', false)
          } else {
            this.searchLoading = false
          }
          EventBus.$emitSticky('loadPaneNoData', true)
        })
      }).catch((e) => {
        if (init) {
          EventBus.$emit('onLoading', false)
        } else {
          this.searchLoading = false
        }
        EventBus.$emitSticky('loadPaneNoData', false)
      })
    },

    loadNewList () {
      this.hideReport()
      return new Promise((resolve, reject) => {
        this.apiLoading = true
        this.listOption.pageNum = 0
        this.promiseListData().then(result => {
          setTimeout(() => {
            this.rankingData = normalizeHeatmapListData(result)
            if (result.length < 20) {
              this.listLoading = null
            } else {
              this.listLoading = false
            }
            this.apiLoading = false
            resolve(result)
          }, 300)
        }).catch(error => {
          reject(error)
          setTimeout(() => {
            this.apiLoading = false
          }, 300)
        })
      })
    },

    loadNextList () {
      if (this.loaded && this.listLoading === false) {
        this.listLoading = true
        this.listOption.pageNum++
        this.promiseListData().then(result => {
          if (result.length) {
            const normalizerList = normalizeHeatmapListData(result)
            this.rankingData = this.rankingData.concat(normalizerList)
          }
          this.listLoading = false
          if (result.length < 20) {
            this.listLoading = null
          }
        }).catch(() => {
          this.listLoading = null
        })
      }
    },

    promiseCardData () {
      return new Promise((resolve, reject) => {
        const term = this.keyword ? this.searchOption : null
        const text = this.keyword || null
        const bookmark = this.dataOption.bookmark
        const subSid = this.dataOption.subSid
        const firstPathname = this.dataOption.firstPath

        getCardPvData({
          start: this.dataOption.start,
          end: this.dataOption.end,
          sid: this.dataOption.sid,
          subSid,
          device: this.dataOption.device,
          refer: this.dataOption.refer,
          aiRefererIds: this.dataOption.aiRefererIds,
          exist: this.dataOption.exist,
          utm: this.dataOption.utm,
          survey: this.dataOption.survey,
          matchType: this.dataOption.matchType,
          term,
          text,
          bookmark,
          firstPathname,
          isCustomNode: this.dataOption.isCustomNode
        }, true).then(pvResult => {
          if (subSid || term || text || bookmark) {
            resolve({
              pv: pvResult,
              session: null
            })
          } else {
            getCardSessionData({
              start: this.dataOption.start,
              end: this.dataOption.end,
              sid: this.dataOption.sid,
              subSid: this.dataOption.subSid,
              device: this.dataOption.device,
              refer: this.dataOption.refer,
              aiRefererIds: this.dataOption.aiRefererIds,
              exist: this.dataOption.exist,
              utm: this.dataOption.utm,
              survey: this.dataOption.survey,
              matchType: this.dataOption.matchType,
              isCustomNode: this.dataOption.isCustomNode
            }, true).then(sessionResult => {
              resolve({
                pv: pvResult,
                session: sessionResult.total
              })
            }).catch(() => {
              resolve({
                pv: pvResult,
                session: null
              })
            })
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    promiseListData () {
      return new Promise((resolve, reject) => {
        let sort = this.listOption.sort
        if (sort.indexOf('resampleCount') > -1) {
          sort = sort.replace('resampleCount', 'pv')
        }
        getListData({
          start: this.dataOption.start,
          end: this.dataOption.end,
          sid: this.dataOption.sid,
          subSid: this.dataOption.subSid,
          firstPathname: this.dataOption.firstPath,
          utm: this.dataOption.utm,
          survey: this.dataOption.survey,
          device: this.dataOption.device,
          refer: this.dataOption.refer,
          aiRefererIds: this.dataOption.aiRefererIds,
          exist: this.dataOption.exist,
          matchType: this.dataOption.matchType,
          pageId: this.listOption.pageNum,
          sortBy: sort,
          term: this.listOption.keyword ? this.listOption.searchOption : null,
          text: this.listOption.keyword || null,
          bookmark: this.dataOption.bookmark,
          isCustomNode: this.dataOption.isCustomNode
        }, true).then(result => {
          this.resetAIReportData()
          for (const item of result) {
            const urlObject = linkSet(item.url)
            item.listUrl = simpleUrl(item.url, this.dataOption.matchType, true)
            item.linkUrl = simpleUrl(item.url, this.dataOption.matchType)
            item.linkHost = urlObject[0]
            item.linkPath = urlObject[1]
            item.linkProtocol = urlObject[2]
            if (this.isCustomNode) {
              item.customDisplayName = item.customId === 0 ? this.$t('customTag.untaggedLabel') : item.customValue
            }
          }
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    },

    onScroll () {
      this.heightGap = this.$refs.paneWrap.scrollHeight - this.$refs.paneWrap.clientHeight
      this.scrollTop = this.$refs.paneWrap.scrollTop
      if (this.listLoading === false) {
        if (this.scrollTop > this.heightGap - 300) {
          this.loadNextList(false)
        }
      }
    },

    onTypeHighlighted (value) {
      this.highlightedType = value
    },

    onSearchOptionChange (value) {
      this.searchOption = value
    },

    onSearchFavoriteChange () {
      this.searchFavorite = !this.searchFavorite
      this.searchOption = this.isExactMatchType ? 'url' : 'pageTitle'
      this.searching = false
      this.searched = false
      this.keyword = ''
      this.listOption.keyword = null
      this.listOption.searchOption = null
      this.loadData(false)
    },

    onSubDomainChange (value) {
      this.subDomain = value
      this.searchFavorite = false
      this.searchOption = this.isExactMatchType ? 'url' : 'pageTitle'
      this.searching = false
      this.searched = false
      this.keyword = ''
      this.listOption.keyword = null
      this.listOption.searchOption = null
      this.loadData(false)
    },

    onStartSearching () {
      let bodyListener = (e) => {
        let outside = true

        function composedPath (el) {
          let paths = []
          while (el) {
            paths.push(el)
            if (el.tagName === 'HTML') {
              paths.push(document)
              paths.push(window)
              return paths
            }
            el = el.parentElement
          }
        }

        const path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target)
        if (path) {
          for (const el of path) {
            if (el.id && el.id === 'rankingSearch') {
              outside = false
            }
          }
        }
        if (outside) {
          this.searchTyping = false
          setTimeout(() => {
            this.keyword = ''
            this.searchOption = !this.isCustomNode ? (this.isExactMatchType ? 'url' : 'pageTitle') : 'customValue'
          }, 300)
          document.body.removeEventListener('click', bodyListener)
        }
      }

      this.searchTyping = true
      document.body.addEventListener('click', bodyListener, false)
    },

    onSearch () {
      if (this.searching) {
        if (this.searchTyping) {
          this.searchLoading = true
          if (this.keyword) {
            this.promiseCardData().then(result => {
              this.infoData = {
                count: result.pv.basicInfo.totalUrlCount,
                pv: result.pv.basicInfo.totalPV,
                bookmarkCount: result.pv.basicInfo.bookmarkCount
              }
              this.listOption.keyword = this.keyword
              this.listOption.searchOption = this.searchOption
              this.loadNewList().then(() => {
                setTimeout(() => {
                  this.searchLoading = false
                  this.searched = true
                }, 300)
              }).catch(() => {
                this.rankingData = []
                setTimeout(() => {
                  this.searchLoading = false
                  this.searched = true
                  this.listOption.keyword = this.keyword
                  this.listOption.searchOption = this.searchOption
                }, 300)
              })
            }).catch(() => {
              this.infoData = {
                count: 0,
                pv: 0,
                bookmarkCount: 0
              }
              setTimeout(() => {
                this.searchLoading = false
                this.searched = true
                this.listOption.keyword = this.keyword
                this.listOption.searchOption = this.searchOption
              }, 300)
            })
          } else {
            this.resetSearch()
          }
        } else {
          this.$refs.keyword.focus()
        }
      } else {
        this.searching = true
        this.searched = false
        this.listOption.keyword = ''
        this.listOption.searchOption = null
        this.$refs.keyword.focus()
      }
    },

    onGroupingChange () {
      this.grouping = !this.grouping
    },

    onGroupChange (value) {
      if (this.group !== value) {
        this.group = value
      }
    },

    onSettingGroup () {
      this.$router.push({ name: 'group', query: { sid: this.$route.query.sid, subSid: this.$route.subSid } })
    },

    onDownloadExcel () {
      if (this.infoData.count > 1000) {
        this.onExcelAlerting(true)
      }
      this.apiLoading = true
      let sort = this.listOption.sort
      const isSampling = this.domain.preSamplingRate < 100 || this.domain.postSamplingRate < 100
      getListData({
        start: this.dataOption.start,
        end: this.dataOption.end,
        sid: this.dataOption.sid,
        subSid: this.dataOption.subSid,
        firstPathname: this.dataOption.firstPath,
        utm: this.dataOption.utm,
        survey: this.dataOption.survey,
        device: this.dataOption.device,
        refer: this.dataOption.refer,
        aiRefererIds: this.dataOption.aiRefererIds,
        exist: this.dataOption.exist,
        matchType: this.dataOption.matchType,
        pageId: -1,
        sortBy: sort,
        term: this.listOption.searchOption ? this.listOption.searchOption : null,
        text: this.listOption.keyword || null,
        bookmark: this.dataOption.bookmark,
        groupId: this.group,
        isCustomNode: this.dataOption.isCustomNode
      }, true).then(result => {
        let fileName = this.journeyOptions.domain + '_Ranking'
        let excel = new Excel()
        this.apiLoading = true
        let sortText = this.listOption.sort.replace('-', '')

        excel.setRankingInfo({
          ...this.infoData,
          timezone: this.domain.timezone,
          timezoneName: this.domain.timezoneName,
          subDomain: this.subDomain ? this.subDomainItems.find(el => {
            if (el.value === this.subDomain) {
              return true
            }
            return false
          }).text : null,
          bookmark: this.searchFavorite,
          term: this.searchOption,
          keyword: this.keyword,
          sort: this.$t('ranking.excel.' + sortText)
        }, isSampling, this.originRankingData).then(() => {
          excel.setRankingData(result, this.listOption.sort.replace('-', ''), !this.listOption.sort.includes('-') ? this.infoData.count : 1, this.grouping && this.group, isSampling, this.originRankingData)
            .then(() => {
              excel.download(fileName)
              this.apiLoading = false
            })
        }).catch(() => {
          this.apiLoading = false
        })
      })
    },

    onCapture (pageData, device) {
      this.capturingPage = pageData
      this.capturingDevice = device
    },

    onCaptureProcessing (key) {
      this.captureProcessing = key
    },

    changeSort (sort) {
      // if (this.isSampling && sort === 'pv') {
      //   sort = 'resampleCount'
      // }
      if (this.listOption.sort === '-' + sort) {
        this.listOption.sort = sort
      } else {
        this.listOption.sort = '-' + sort
      }
      this.loadNewList().then(async listResult => {
        this.rankingData = normalizeHeatmapListData(listResult)
      })
    },
    changeState () {
      this.loadNewList().then(async listResult => {
        this.rankingData = normalizeHeatmapListData(listResult)
      })
    },
    makeFavorite (pageData) {
      if (!pageData.bookmark && this.numBookmarks >= this.numMaxBookmarks) {
        this.setBookmarkListLayerOptions({
          mode: 'manage'
        })
      } else {
        const bookmark = {
          sid: this.dataOption.sid,
          matchType: this.dataOption.matchType,
          gUrlId: pageData.gUrlId,
          addBookmark: !pageData.bookmark
        }

        if (this.journeyOptions.matchType === 'exact') {
          bookmark.url = pageData.url
        }
        makeFavorite(bookmark, true)
          .then(response => {
            if (response.updated) {
              this.$set(pageData, 'bookmark', response.bookmark)
              this.storeBookmarkCount()
            }
          })
          .catch((e) => {
            EventBus.$emit('onError')
          })
      }
    },
    onHeatmapRegistration (pageData) {
      if (pageData.baApply) {
        this.isHeatmapEditMode = true
      } else {
        this.isHeatmapEditMode = false
      }
      this.nodeDataForHeatmap = pageData
      this.isHeatmapRegistration = true
    },
    onCloseHeatmapRegistration (register = false) {
      this.nodeDataForHeatmap = null
      this.isHeatmapRegistration = false
      this.isHeatmapRegistrationClose = register
      if (!register) {
        this.changeState()
      }
    },
    registerDone () {
      this.isHeatmapEditMode = false
      this.isHeatmapRegistrationClose = false
      this.changeState()
    },
    onHeatmapRegister () {
      this.isHeatmapEditMode = false
      this.isHeatmapRegistrationClose = false
    },
    showReport (pageData) {
      if (!pageData) {
        this.hideReport()
      } else {
        this.hideReport(false)
        this.apiLoading = true
        getDetail({
          start: this.dataOption.start,
          end: this.dataOption.end,
          sid: this.dataOption.sid,
          subSid: this.dataOption.subSid,
          matchType: this.dataOption.matchType,
          utm: this.dataOption.utm,
          survey: this.dataOption.survey,
          device: this.dataOption.device,
          refer: this.dataOption.refer,
          aiRefererIds: this.dataOption.aiRefererIds,
          exist: this.dataOption.exist,
          gUrlId: pageData.gUrlId,
          customId: this.isCustomNode ? pageData.customId : null,
          isCustomNode: this.isCustomNode,
          url: pageData.url
        }, true).then(result => {
          const urlObject = linkSet(pageData.url)
          pageData.listUrl = simpleUrl(pageData.url, this.dataOption.matchType, true)
          pageData.linkUrl = simpleUrl(pageData.url, this.dataOption.matchType)
          pageData.linkHost = urlObject[0]
          pageData.linkPath = urlObject[1]
          pageData.linkProtocol = urlObject[2]

          this.reportShowing = pageData
          this.reportShowingData = result

          this.reportShowingData.imagePath = this.reportShowingData.imagePath || {}
          this.reportShowingData.realCaptureDate = {
            desktop: getS3CaptureDatetime(this.reportShowingData.imagePath['desktop']) || this.reportShowingData.captureDate,
            tablet: getS3CaptureDatetime(this.reportShowingData.imagePath['tablet']) || this.reportShowingData.captureDate,
            phone: getS3CaptureDatetime(this.reportShowingData.imagePath['phone']) || this.reportShowingData.captureDate
          }

          setTimeout(() => {
            this.apiLoading = false
            this.openNodeReport = true
          }, 300)
        })
      }
    },

    hideReport (close = true) {
      this.openNodeReport = false
      if (close) {
        setTimeout(() => {
          this.reportShowing = null
          this.reportShowingData = null
        }, 300)
      }
    },

    resetSegments () {
      this.keyword = ''
      this.searchOption = this.isExactMatchType ? 'url' : 'pageTitle'
      this.searchFavorite = false
      this.searching = false
      this.searched = false
      this.listOption.keyword = null
      this.listOption.searchOption = null
      this.listOption.pageNum = 0
      this.listOption.sort = '-pv'
      this.subDomain = null
    },

    resetSearch () {
      this.resetSegments()
      this.loadData(false)
    },

    onDateAlerting (value = true) {
      this.dateLimitAlerting = value
    },

    onExcelAlerting (value = true) {
      this.excelAlerting = value
    },

    changeCategory (value) {
      this.domainSubCategory = value
      this.getBenchmarkData()
      this.isCategorySelectorOpened = false
    },
    onClickAiReport () {
      if (!this.ableToShowAiReport) return
      EventBus.$emit('setSegmentPayment')
    }
  },

  watch: {
    'journeyPeriod' () {
      this.resetSegments()
    },
    'journeyOptions.utm' () {
      this.resetSegments()
    },
    grouping () {
      this.groupOning = true
      setTimeout(() => {
        this.groupOning = false
      }, 500)
    }
  },

  data () {
    return {
      isShiftJam: false,
      isChargingJam: false,
      TopUpResult: false,
      showTopUpAlert: false,
      jamCount: 0,
      remainJam: 0,
      registDone: false,
      nodeDataForHeatmap: null,
      loaded: false,
      listLoading: false,
      searchLoading: false,
      isHeatmapRegistration: false,
      apiLoading: false,
      movingGroup: false,

      scrollTop: 0,
      heightGap: 0,
      highlightedType: null,
      reportShowing: null,
      reportShowingData: null,
      openNodeReport: false,
      defaultThumbnail: null,
      capturingPage: null,
      capturingDevice: null,
      captureProcessing: null,

      infoData: null,
      cardData: null,
      rankingData: null,

      keyword: '',
      searchTyping: false,
      searchOption: 'pageTitle',
      searchFavorite: false,
      searched: false,
      searching: false,
      listOption: {
        keyword: null,
        searchOption: null,
        pageNum: 0,
        sort: '-pv'
      },

      subDomain: null,
      subDomainItems: [
        {
          text: null,
          value: null
        }
      ],

      group: 1,
      grouping: false,
      groupOning: false,
      groupItems: [],

      noData: false,
      excelAlerting: false,
      dateLimitAlerting: false,
      canBookmarkSearch: true,
      isHeatmapRegistrationClose: false,
      isHeatmapEditMode: false,
      wholeCaptureProcessing: [],
      benchmarkData: null,
      samplingReliabilityText: null,
      isCategorySelectorOpened: false,
      domainSubCategory: null,
      categoryList: null,
      DOMAIN_CATEGORY_ICON
    }
  }
}
</script>

<style lang="scss" scoped>
$categoryText: #0185FF;
.ba-ranking {
  position: relative;
  height: 100%;
  &.shared {
    .setting__wrap .setting {
      pointer-events: none;
      opacity: .3;
    }
  }
  .insert-page-wrap {
  }
  .pane-wrap {
    position: relative;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;

    .info-wrap {
      z-index: 8;
      position: sticky;
      top: 0;
      left: 0;
      width: 100%;
      transform: translateZ(0);
      transition: box-shadow 0.3s ease,
      background-color 0.3s ease;
      .info {
        height: 32px;
        padding: 25px 20px 15px 20px;
        line-height: 32px;
        max-width: 1560px;
        margin: 0 auto;
        color: #7d7d7d;
        transition: color 0.3s ease;
        display: flex;
        align-items: center;
        .custom {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 8px;
          margin-right: 15px;
          .label {
            color: #7D7D7D;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 12px; /* 100% */
            display: inline-block;
          }
        }
        .domain {
          // float: left;
          // padding-left: 8px;

          .ui-select {
            margin-left: 5px;
            transform: translateY(-1px);
          }

          button {
            position: relative;
            height: 32px;
            box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
            background-color: #ffffff;
            border-radius: 4px;
            vertical-align: middle;
            margin-left: 5px;
            transition: box-shadow 0.2s ease,
            opacity 0.2s ease,
            background-color 0.2s ease;
            padding: 0 12px 0 25px;
            top:-1px;
            &:hover {
              background-color: rgba(0, 0, 0, 0.06);
            }

            &:disabled {
              opacity: 0.3;
              cursor: default;
              pointer-events: none;
            }

            i.icon {
              position: absolute;
              top: 7px;
              left: 7px;
              width: 18px;
              height: 18px;
              opacity: 0;
              transition: opacity 0.2s ease;

              &.off {
                opacity: 1;
              }
            }

            &.active {
              background: linear-gradient(0deg, #888 0%, #666 99.97%);
              box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.30) inset;

              .bookmark-text {
                color: #ffffff;
              }
              i.icon {
                opacity: 1;

                &.off {
                  opacity: 0;
                }
              }
            }

            .bookmark-text {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-self: stretch;
              padding-left: 7px;
              font-weight: 600;
              font-size: 13px;
              line-height: 13px;
              color: #2F2F2F;
            }
          }

          &::after {
            content: "";
            width: 1px;
            height: 16px;
            background-color: #d1d1d1;
            display: inline-block;
            margin: 4px 6px -4px 8px;
            // transition: background-color 0.3s ease;
          }
        }

        .search {
          position: relative;
          float: left;

          .search-option {
            display: inline-block;
            width: 0;
            height: 32px;
            margin: 0 0 0 1px;
            transform: translateY(-1px);
            vertical-align: top;
            opacity: 0;
            transition: width 0.2s ease,
            opacity 0.2s ease,
            margin 0.2s ease,
            padding-right 0.2s ease;
          }

          .search-input {
            display: inline-block;
            height: 32px;
            width: 32px;
            transition: width 0.2s ease;

            input {
              border: none;
              width: calc(100% - 42px);
              height: 30px;
              padding: 0 22px 0 10px;
              line-height: 30px;
              border-radius: 4px;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
              background-color: #ffffff;
              color: #444444;
              transition: box-shadow 0.15s ease,
              background-color 0.3s ease,
              color 0.3s ease,
              padding-right 0.2s ease;

              &:focus {
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px #299eee !important;
              }

              &:disabled {
                opacity: 0.3;
                cursor: default;
              }
            }
          }

          .search-button {
            position: absolute;
            top: 0;
            right: 0;
            width: 32px;
            height: 32px;

            &:hover {
              border-radius: 4px;
              background-color: rgba(0, 0, 0, 0.12);
            }

            &:disabled {
              opacity: 0.3;
              cursor: default;
            }

            svg {
              position: absolute;
              top: 8px;
              right: 8px;
              width: 16px;
              height: 16px;

              g {
                stroke: #666666;
                transition: stroke 0.3s ease;
              }
            }
          }

          &.searching {
            .search-option {
              width: 140px;
              padding-right: 5px;
              margin: 0 1px;
              opacity: 1;

              &.custom {
                width: initial;
                padding-right: 10px;
                position: relative;
                display: inline-flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: nowrap;

                span {
                  color: #7D7D7D;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: 12px;
                }
              }
            }

            .search-input {
              width: 200px;

              input {
                padding-right: 32px;
              }
            }
          }
        }

        .info-data {
          flex-grow: 1;
          display: flex;
          align-items: center;
          width: 300px;
          white-space: nowrap;
          transition: opacity 0.3s ease,
          width 0.3s ease;

          &.searching {
            width: 0;
            opacity: 0;
          }
          .sampling-reliability {
            display: flex;
            align-items: center;
            gap: 5px;
            padding: 0 8px;
            .icon-wrap {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background: #FFB427;
              box-sizing: border-box;
            }
            .message {
              color: #2f2f2f;
              font-size: 13px;
              font-weight: 400;
            }
          }
        }

        .url {
          display: inline-block;
          padding-left: 20px;
          color: #555555;
          transition: color 0.3s ease;

          &::after {
            content: "";
            width: 1px;
            height: 8px;
            background-color: #d1d1d1;
            display: inline-block;
            margin-left: 10px;
          }

          em {
            color: #888888;
            transition: color 0.3s ease;
          }
        }

        .session {
          display: inline-block;
          padding: 0 0 0 12px;
          color: #555555;
          transition: color 0.3s ease;

          &::after {
            content: "";
            width: 1px;
            height: 8px;
            background-color: #d1d1d1;
            display: inline-block;
            margin-left: 10px;
          }

          em {
            color: #0e90a5;
          }
        }

        .pv {
          display: inline-block;
          padding: 0 12px;
          color: #555555;
          transition: color 0.3s ease;

          em {
            color: #ec0047;
          }
        }

        .alarm {
          display: inline-block;
          padding-left: 22px;
          color: #555555;
          transition: color 0.3s ease;

          i {
            margin-top: 6px;
            float: left;
          }
          span {
            vertical-align: middle;
            margin-left: 5px;
          }
        }

        .buttons {
          margin-top: -1px;
          // margin-right: 10px;
          display: flex;
          align-items: center;
          .group {
            display: inline-flex;
            align-items: center;
            position: relative;

            .label {
              vertical-align: middle;
              margin-right: 5px;

              .icon {
                margin-top: -2px;
                vertical-align: middle;

              }
            }

            .group-setting {
              white-space: nowrap;
              display: inline-block;
              vertical-align: top;
              width: 0;
              opacity: 0;
              transition: width 0.3s ease,
              opacity 0.3s ease;

              &.active {
                width: 206px;
                opacity: 1;
              }

              &.moving {
                overflow: hidden;
              }

              .group-options {
                margin: 0 8px 0 10px;
              }

              .icon--setting-size16 {
                cursor: pointer;
                vertical-align: middle;
                padding: 3px;
                margin: -3px;
                border-radius: 20px;
                background-size: 16px 16px;
                transition: background-color 0.2s ease;

                &:hover {
                  background-color: rgba(0, 0, 0, 0.06);
                }
              }
            }

            &::after{
              content: "";
              display: inline-block;
              vertical-align: middle;
              width: 1px;
              height: 16px;
              margin: 0 10px 0 8px;
              background-color: #d1d1d1;
            }

            &.disabled {
              pointer-events: none;
              & > .ba-switch {
                & > button {
                  &.disabled {
                    opacity: 0.3;
                  }
                }
              }
            }
          }
          .setting__wrap {
            display: inline-block;
            z-index: 5;
            position: relative;
            .setting {
              border-radius: 4px;
              background: #FFF;
              box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 0px 0px 1px rgba(0, 0, 0, 0.06);
              padding: 7px 8px 7px 31px;
              font-size: 13px;
              font-style: normal;
              font-weight: 600;
              color: #333;
              height: 32px;
              line-height: 16px;
              position: relative;
              .icon--setting-size16 {
                position: absolute;
                left: 8px;
                top: 25%;
              }
              &.theme {
                background-color: #555;
                color: #fff;
                &:hover {
                  background-color: rgba(255, 255, 255, 0.3);
                }
              }
              &:hover {
                background-color: rgba(0, 0, 0, 0.06);
              }
              &.disabled {
                pointer-events: none;
                opacity: 0.3;
              }
            }
            &::after{
              content: "";
              display: inline-block;
              vertical-align: middle;
              width: 1px;
              height: 16px;
              margin: 0 10px 0 8px;
              background-color: #d1d1d1;
            }
          }

          .excel {
            display: inline-block;
            position: relative;

            button {
              padding: 1px 4px 1px 8px;
              height: 32px;
              border-radius: 5px;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
              background-color: #fff;
              color: #444444;
              transition: background-color 0.2s ease,
              box-shadow 0.2s ease,
              color 0.3s ease;

              &:hover {
                background-color: rgba(0, 0, 0, 0.06);
              }

              &:active {
                background-image: linear-gradient(to top, #888888 0%, #666666 100%);
                box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(0, 0, 0, 0.06);
                color: #ffffff;

                i.icon {
                  background-image: url(../../assets/img/journey/icon--excel-white.svg);
                }
              }

              i.icon {
                vertical-align: middle;
                margin-right: 4px;
                margin-top: -2px;
              }
            }
          }
          .ai-report-button {
            position: relative;
            display: flex;
            height: 32px;
            padding: 4px 10px 4px 6px;
            margin-left: 21px;
            align-items: center;
            gap: 4px;
            border-radius: 5px;
            background-color: #fff;
            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 3px 4px -2px rgba(0, 0, 0, 0.12);
            box-sizing: border-box;
            color: #555;
            cursor: pointer;
            .text-contents {
              min-width: 41px;
              font-size: 13px;
              font-weight: 500;
              text-align: center;
            }
            &:hover {
              background-color: rgba(0, 0, 0, 0.06);
            }
            &:disabled {
              opacity: 0.3;
              pointer-events: none;
            }
            &:before {
              content: '';
              position: absolute;
              top: 50%;
              left: -10px;
              transform: translate(-50%, -50%);
              width: 1px;
              height: 16px;
              background-color: #D1D1D1;
            }
          }
        }
      }

      .searching-keyword {
        height: 0;
        overflow: hidden;
        transition: height 0.3s cubic-bezier(.28,.12,.42,.94);

        .searching-wrap {
          padding: 8px 30px;
          max-width: 1380px;
          margin: 0 auto;
        }

        .reset {
          width: 31px;
          height: 31px;
          border-radius: 5px;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px #666666;
          background-color: #1c1c1c;
          color: #444444;
          transition: background-color 0.2s ease,
          box-shadow 0.2s ease,
          color 0.3s ease;

          &:hover {
            background-color: #333333;
          }

          &:active {
            background-image: linear-gradient(to top, #777777 0%, #555555 100%);
            box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 0 0 1px #666666;
            color: #ffffff;
          }

          i.icon {
            vertical-align: middle;
            transform: translate(-1px, -0.5px);
          }
        }

        .search-keyword {
          display: inline-block;
          font-size: 18px;
          vertical-align: middle;
          color: #bababa;
          margin: 0 20px;

          & /deep/ em {
            color: #fe8501;
          }
        }

        .search-result {
          display: inline-block;
          margin-left: 15px;
          font-size: 12px;
          vertical-align: middle;
          color: #888888;

          em {
            color: #ffffff;
          }
        }
      }

      &.searched {
        .searching-keyword {
          height: 54px;
        }
      }
    }
    .benchmark-wrap {
      display: flex;
      align-items: center;
      max-width: 1560px;
      margin: 0 auto;
      padding: 10px 25px 4px;
      .match-type {
        position: relative;
        padding: 4.5px 8px;
        margin-right: 21px;
        border-radius: 25px;
        background: #2C7899;
        color: #FFF;
        font-size: 13px;
        font-weight: 500;
        text-transform: capitalize;
        cursor: default;
        &.exact {
          background: #005BAD;
        }
        &::after {
          content: '';
          position: absolute;
          right: -10px;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 16px;
          background: #D1D1D1;
        }
      }
      .category-header {
        width: 100%;
        display: flex;
        align-items: center;

        color: #444;
        font-size: 14px;
        font-weight: 600;
        line-height: 1.2;
        .category-icon {
          margin-right: 8px;
        }

        .dropdown {
          position: relative;
          cursor: pointer;
          margin-right: 12px;
          .selected {
            display: flex;
            align-items: center;
            gap: 12px;
            border-radius: 6px;
            border: solid 1px #bbb;
            background-color: #ffffff;
            padding: 8px 8px 8px 10px;
            cursor: pointer;
            .label {
              width: 114px;
              font-size: 14px;
              font-weight: 600;
              line-height: 1;
              color: #0185FF;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .icon {
              flex-shrink: 0;
            }
          }
        }
        .ai-robot-burrow {
          width: 41px;
          height: 41px;
          margin-left: 15px;
          transform: translateY(-5px);
          background: url('../../assets/img/dashboard/ai-robot-burrow.svg') no-repeat center;
          background-size: container;
          &.invert-h {
            transform: translateY(-5px) scaleX(-1);
            margin-left: 0;
            margin-right: 15px;
          }
        }
        .segment-notice {
          position: relative;
          color: #666;
          font-size: 12px;
          font-weight: 400;
          margin-left: 28px;
          &::before {
            position: absolute;
            left: -13px;
            top: 50%;
            transform: translateY(-50%);
            content: '';
            width: 1px;
            height: 16px;
            background-color: #D1D1D1;
          }
        }
      }
    }
    .card-wrap {
      height: 410px;
      padding: 20px;
      max-width: 1560px;
      margin: 0 auto;
      transform: translateZ(0);

      &.no-data {
        height: 340px;
      }

      .fade-leave-active,
      .fade-enter-active {
        transition: opacity 0.3s ease;
      }

      .fade-enter,
      .fade-leave-to {
        overflow: hidden;
        height: 0;
      }
    }

    .list-wrap {
      padding: 0 20px 20px;
      max-width: 1560px;
      margin: 0 auto;

      &.no-data {
        min-height: calc(100% - 146px);
        height: 0;
      }
    }

    .back-to-top {
      position: fixed;
      right: 25px;
      bottom: 25px;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    // animation off

    .info-wrap {
      transition: none !important;

      .info {
        transition: none !important;

        .domain {
          transition: none !important;

          button {
            transition: none !important;
          }
        }

        .search {
          .search-input {
            input {
              transition: none !important;
            }
          }

          .search-button {
            svg {
              g {
                transition: none !important;
              }
            }
          }
        }

        .url {
          transition: none !important;

          em {
            transition: none !important;
          }
        }

        .session {
          transition: none !important;
        }

        .pv {
          transition: none !important;
        }

        .buttons {
          transition: none !important;

          button {
            transition: none !important;
          }
        }
      }
    }

    // animation off - end

    &.scrolled {
      .info-wrap {
        box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.35);
        background-color: #252525;

        .info {
          color: #bbbbbb;

          .domain {
            button {
              background-color: #555555;

              .bookmark-text {
                color: #fff;
              }

              &.active {
                background: linear-gradient(0deg, #535353 0%, #424242 99.97%);
              }
              &:hover {
                background-color: rgba(255, 255, 255, 0.3);
              }
            }

            &::after {
              background-color: #535353;
            }
          }

          .search {
            .search-input {
              input {
                color: #ffffff;
                background-color: #555555;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
              }
            }

            .search-button {
              svg {
                g {
                  stroke: #ffffff;
                }
              }
              &:hover {
                border-radius: 4px;
                background-color: rgba(255, 255, 255, 0.12);
              }
            }
          }

          .url {
            color: #bbbbbb;

            em {
              color: #bbbbbb;
            }

            &::after {
              background-color: #555555;
            }
          }

          .session {
            color: #bbbbbb;

            &::after {
              background-color: #555555;
            }
          }

          .pv {
            color: #bbbbbb;

            &::after {
              background-color: #555555;
            }
          }
          .sampling-reliability {
            .message {
              color: #bbbbbb;
            }
          }
          .alarm {
            color: #bbbbbb;

            &::after {
              background-color: #555555;
            }
          }

          .buttons {
            margin-top: -1px;

            .group, .setting__wrap{
              &::after {
                background-color: #555555;
              }
            }

            button {
              color: #d1d1d1;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px #666666;
              background-color: #1c1c1c;

              &:hover {
                background-color: rgba(255, 255, 255, 0.12);
              }

              &:active {
                background-image: linear-gradient(to top, #777777 0%, #555555 100%);
                box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 0 0 1px #666666;
                color: #ffffff;
              }

            }
          }
        }
      }
    }

    &.scrolledMore {
      .info-wrap {
        box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.13);
      }

      .list-wrap /deep/ {
        .table-wrap table thead {
          z-index: 8;

          &::before {
            border-radius: 0;
            width: calc(100vw + 2px);
            min-width: calc(100% + 42px);
            transform: translateX(calc(-50% - 1px));
          }
        }
      }

      .back-to-top {
        opacity: 1;
      }
    }
  }

  .node-report {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 20;
    width: 430px;
    height: 100%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08), 0 2px 20px -2px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    transition: transform 0.5s ease;

    &.node-report-enter,
    &.node-report-leave-to {
      transform: translate(110%, 0);
    }

    .ba-page-report {
      position: relative;
      z-index: 3;
    }

    .back-dim {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      cursor: pointer;
    }

    .close-report {
      position: absolute;
      z-index: 2;
      top: 50%;
      left: -20px;
      width: 20px;
      height: 50px;
      padding: 17px 0;
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-right: none;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      transform: translateY(-50%);
      background: #ffffff;

      &::after,
      &::before{
        content: "";
        width: 2px;
        height: 2px;
        border: 1px solid rgba(0, 0, 0, 0.08);
        position: absolute;
        right: 0;
        border-left: none;
      }

      &::after{
        border-top: none;
        border-radius: 0 0 5px 0;
        top: -3px;
      }

      &::before{
        border-bottom: none;
        border-radius: 0 5px 0 0;
        bottom: -3px;
      }

      .icon {
        &::after,
        &::before{
          content: "";
          width: 6px;
          height: 6px;
          border: 2px solid #ffffff;
          position: absolute;
          right: -2px;
          border-left: none;
        }

        &::after{
          border-top: none;
          border-radius: 0 0 7px 0;
          top: -6px;
        }

        &::before{
          border-bottom: none;
          border-radius: 0 7px 0 0;
          bottom: -6px;
        }
      }
    }
  }

  .loading {
    position: relative;
    margin: 10px auto 2px;
    padding: 7px;
    border-radius: 8px;
    width: 45px;
    height: 45px;
    z-index: 10;

    .loading-circle {
      position: absolute;
      width: 45px;
      height: 45px;
      transform: translate(-50%, -50%);
      animation: loading 3s linear infinite;
      transition: opacity 0.3s ease;

      svg {
        height: 100%;
      }

      .loading-inner {
        stroke: {
          dashoffset: 0;
          dasharray: 300;
          width: 24;
          miterlimit: 10;
          linecap: round;
        }

        animation: loading-circle 2s linear infinite;
        stroke: $brandColor;
        fill: transparent;
      }
    }
  }

  .pane-no-data {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;

    &.fade-leave-active,
    &.fade-enter-active {
      transition: opacity 0.5s ease;
      opacity: 1;
    }

    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #444444;
      margin: 10px 0 20px 0;
    }

    p {
      font-size: 14px;
      line-height: 1.57;
      color: #666666;
      margin-bottom: 50px;
    }
  }

  .search-loading {
    z-index: 50 !important;
  }

  .fade-leave-active,
  .fade-enter-active {
    transition: opacity 0.3s ease;
    opacity: 1;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  @keyframes loading {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes loading-circle {
    0% {
      stroke-dashoffset: 0
    }
    100% {
      stroke-dashoffset: -600;
    }
  }
}
</style>
